import { useLayoutEffect, useState } from 'react'

let interval = null

const getDimensions = () =>
({
    width: window && window.innerWidth || document.documentElement.clientWidth,
    height: window && window.innerHeight || document.documentElement.clientHeight
});

const useWindowResize = (opts = {}) =>
{
    const options =
    {
        ... { debounce: 500 },
        ...opts
    }

    const [dimensions, setDimensions] = useState(getDimensions())

    useLayoutEffect(() =>
    {
        function onWindowResize()
        {    
            interval && clearTimeout(interval)
            interval = setTimeout(() =>
            {
                setDimensions(getDimensions())
            }, options.debounce);
        }

        window.addEventListener('resize', onWindowResize);
        onWindowResize();

        return () => window.removeEventListener('resize', onWindowResize);
    }, [])

    return dimensions;
}

export default useWindowResize;